import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'om-genstande';
            break;
        case 'om-genstande':
            nextPage = 'indhentning-af-tilbud';
            break;
        case 'indhentning-af-tilbud':
            if (getValueOrDefault(formConfig, formValues, 'erderindhentetettilbudpudbedringafskaden').value === 'Ja') {
                nextPage = 'tilbud-og-pris';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        case 'tilbud-og-pris':
            nextPage = 'politianmeldelse';
            break;
        case 'politianmeldelse':
            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Y') {
                nextPage = 'samtykke';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        case 'samtykke':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
